var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavProductionIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.86,
    height: 42.602,
    viewBox: "0 0 71.86 42.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185187",
    "data-name": "\\uADF8\\uB8F9 185187",
    transform: "translate(-844.471 -434.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185185",
    "data-name": "\\uADF8\\uB8F9 185185",
    transform: "translate(845.179 435.468)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_38",
    "data-name": "\\uC120 38",
    y2: 11.271,
    transform: "translate(7.969 3.733) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M0,4.492,4.516,0,8.961,4.492",
    transform: "translate(5.286) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185185-2",
    "data-name": "\\uADF8\\uB8F9 185185",
    transform: "translate(859.848 435.468)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_38-2",
    "data-name": "\\uC120 38",
    y2: 11.271,
    transform: "translate(7.969 3.733) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23-2",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M0,4.492,4.516,0,8.961,4.492",
    transform: "translate(5.286) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185185-3",
    "data-name": "\\uADF8\\uB8F9 185185",
    transform: "translate(874.517 435.468)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_38-3",
    "data-name": "\\uC120 38",
    y2: 11.271,
    transform: "translate(7.969 3.733) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23-3",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M0,4.492,4.516,0,8.961,4.492",
    transform: "translate(5.286 0) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185185-4",
    "data-name": "\\uADF8\\uB8F9 185185",
    transform: "translate(889.187 435.468)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_38-4",
    "data-name": "\\uC120 38",
    y2: 11.271,
    transform: "translate(7.969 3.733) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23-4",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M0,4.492,4.516,0,8.961,4.492",
    transform: "translate(5.286) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185185-5",
    "data-name": "\\uADF8\\uB8F9 185185",
    transform: "translate(903.856 435.468)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_38-5",
    "data-name": "\\uC120 38",
    y2: 11.271,
    transform: "translate(7.969 3.733) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23-5",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M0,4.492,4.516,0,8.961,4.492",
    transform: "translate(5.286) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185185-6",
    "data-name": "\\uADF8\\uB8F9 185185",
    transform: "translate(845.179 450.137)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_38-6",
    "data-name": "\\uC120 38",
    y2: 11.271,
    transform: "translate(7.969 3.733) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23-6",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M0,4.492,4.516,0,8.961,4.492",
    transform: "translate(5.286) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185185-7",
    "data-name": "\\uADF8\\uB8F9 185185",
    transform: "translate(859.848 450.137)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_38-7",
    "data-name": "\\uC120 38",
    y2: 11.271,
    transform: "translate(7.969 3.733) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23-7",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M0,4.492,4.516,0,8.961,4.492",
    transform: "translate(5.286) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185185-8",
    "data-name": "\\uADF8\\uB8F9 185185",
    transform: "translate(874.517 450.137)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_38-8",
    "data-name": "\\uC120 38",
    y2: 11.271,
    transform: "translate(7.969 3.733) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23-8",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M0,4.492,4.516,0,8.961,4.492",
    transform: "translate(5.286 0) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185185-9",
    "data-name": "\\uADF8\\uB8F9 185185",
    transform: "translate(889.187 450.137)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_38-9",
    "data-name": "\\uC120 38",
    y2: 11.271,
    transform: "translate(7.969 3.733) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23-9",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M0,4.492,4.516,0,8.961,4.492",
    transform: "translate(5.286) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185185-10",
    "data-name": "\\uADF8\\uB8F9 185185",
    transform: "translate(903.856 450.137)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_38-10",
    "data-name": "\\uC120 38",
    y2: 11.271,
    transform: "translate(7.969 3.733) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23-10",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M0,4.492,4.516,0,8.961,4.492",
    transform: "translate(5.286) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185185-11",
    "data-name": "\\uADF8\\uB8F9 185185",
    transform: "translate(845.179 464.806)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_38-11",
    "data-name": "\\uC120 38",
    y2: 11.271,
    transform: "translate(7.969 3.733) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23-11",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M0,4.492,4.516,0,8.961,4.492",
    transform: "translate(5.286) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185185-12",
    "data-name": "\\uADF8\\uB8F9 185185",
    transform: "translate(859.848 464.806)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_38-12",
    "data-name": "\\uC120 38",
    y2: 11.271,
    transform: "translate(7.969 3.733) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23-12",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M0,4.492,4.516,0,8.961,4.492",
    transform: "translate(5.286) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185185-13",
    "data-name": "\\uADF8\\uB8F9 185185",
    transform: "translate(874.517 464.806)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_38-13",
    "data-name": "\\uC120 38",
    y2: 11.271,
    transform: "translate(7.969 3.733) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23-13",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M0,4.492,4.516,0,8.961,4.492",
    transform: "translate(5.286 0) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185185-14",
    "data-name": "\\uADF8\\uB8F9 185185",
    transform: "translate(889.187 464.806)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_38-14",
    "data-name": "\\uC120 38",
    y2: 11.271,
    transform: "translate(7.969 3.733) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23-14",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M0,4.492,4.516,0,8.961,4.492",
    transform: "translate(5.286) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185185-15",
    "data-name": "\\uADF8\\uB8F9 185185",
    transform: "translate(903.856 464.806)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_38-15",
    "data-name": "\\uC120 38",
    y2: 11.271,
    transform: "translate(7.969 3.733) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23-15",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M0,4.492,4.516,0,8.961,4.492",
    transform: "translate(5.286) rotate(45)",
    fill: "none",
    stroke: "#f8c44f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavProductionIcon2);
export default __webpack_public_path__ + "static/media/navProductionIcon2.63d65eb927376c318dcf208f927d0412.svg";
export { ForwardRef as ReactComponent };